import { z } from "zod";

export const NoteFactNodeContentSchema = z.object({
  nodeType: z.literal("note"),
  version: z.literal("1"),

  body: z
    .string()
    .min(1)
    .max(5000)
    .describe("The main content or hint of the note."),
  title: z
    .string()
    .min(1)
    .max(120)
    .optional()
    .describe("A short title for the note."),
});

export const NoteOnPersonFactEdgeMetadataSchema = z.object({
  edgeType: z.literal("noteOnPerson"),
  version: z.literal("1"),
});
